export function NumberToUint8(num: number): Uint8Array {
  // Handle floating-point numbers by including both integer and fractional parts
  const buffer = new ArrayBuffer(8)
  const view = new DataView(buffer)

  // Store as 64-bit float to preserve both integer and fractional parts
  view.setFloat64(0, num, false) // false = big endian

  return new Uint8Array(buffer)
}
